<template>
  <div style="display:flex;  align-items: center; justify-content: center">
    <img src="@/assets/404.png" style="object-fit: fill;height:100vh; width:100vh; display: flex;" />
  </div>
</template>

<script>
export default {};
</script>
